import React, { useLayoutEffect, useState } from 'react';

import {
  CollaborativeItem,
  CollaborativeListParams,
  ShareSource,
  getCollaborativeList,
} from '@mygpt/app/collaborate/services';

export const useCollaborativeList = () => {
  const [loading, setLoading] = React.useState(false);

  const [data, setData] = useState<CollaborativeItem[]>([]);
  const [error, setError] = useState<Error | null>(null);
  const [page, setPage] = React.useState<{ page: number; total: number; size: number; pages: number }>({
    page: 1,
    total: data.length,
    pages: 1,
    size: 1000,
  });

  const loadList = React.useCallback(async (params: CollaborativeListParams) => {
    setLoading(true);
    return getCollaborativeList({ size: 1000, ...params })
      .then((res) => {
        setData(res.data.items);
        setPage({
          page: res.data.page,
          total: res.data.total,
          pages: res.data.pages,
          size: res.data.size,
        });
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handlePageChange = React.useCallback(
    (options: Partial<{ page: number; size: number }>) => setPage((prev) => ({ ...prev, ...options })),
    []
  );

  // useLayoutEffect(() => {
  //   loadList({ page: page.page, size: page.size, ai_type: activeTab });
  // }, [loadList, page.page, page.size, activeTab]);

  return {
    error,
    loading,
    data,
    page,
    setPage: handlePageChange,
    loadList,
  };
};
